/* eslint-ignore */
// @ts-nocheck
import React, { useState } from 'react';

import { BsEyeSlash, BsEye } from 'react-icons/bs';

import { InpuWrapError, Container, Input, Label, Error } from './styles';

function CustomInput({
  labelText,
  inputId,
  inputName,
  inputType,
  value,
  onChange,
  onBlur,
  onFocus,
  icon: Icon,
  msgError,
  ...rest
}) {
  const [isFocus, setIsfocus] = useState(false);
  const [showPass, setShowPass] = useState(false);

  return (
    <InpuWrapError>
      <Container withIcon={!!Icon} {...rest} $whitError={!!msgError}>
        {Icon && <Icon size={28} />}
        <Label $isFocus={isFocus || value}>{labelText}</Label>
        <Input
          id={inputId}
          name={inputName}
          type={
            inputType === 'password'
              ? showPass
                ? 'text'
                : 'password'
              : inputType
          }
          value={value}
          onChange={(e) => onChange(e)}
          onFocus={() => {
            setIsfocus(true);
            onFocus && onFocus();
          }}
          onBlur={() => {
            setIsfocus(false);
            onBlur && onBlur();
          }}
        />
        {inputType === 'password' && (
          <>
            {!showPass && (
              <BsEyeSlash
                className="iconPass"
                size={28}
                onClick={() => setShowPass(!showPass)}
              />
            )}
            {showPass && (
              <BsEye
                className="iconPass"
                size={28}
                onClick={() => setShowPass(!showPass)}
              />
            )}
          </>
        )}
      </Container>
      {msgError && <Error>{msgError}</Error>}
    </InpuWrapError>
  );
}

export default CustomInput;
